import { Injectable } from "@angular/core";
import { UnitaDocumentariaVO } from "@app/shared/vo/unita-documentariaVO";
import { CorrispondenzaPartenzaVO } from "@app/shared/vo/gescor/corrispondenza-partenzaVO";
import { ClassificaGescorVO } from "@app/shared/vo/gescor/classifica-gescorVO";
import { TipoSupportoDocumentoEnum } from "@app/shared/enum/tipo-supporto-documento-enum";
import { TipoProtocolloEnum } from "@app/shared/enum/tipo-protocollo-enum";
import { FormCreaCorrispondenzaPartenzaVO } from "@app/shared/vo/gescor/form-crea-corrispondenza-partenzaVO";
import { ClassificaVO } from "@app/shared/vo/classificaVO";
import { DestinatarioVO } from "@app/shared/vo/gescor/destinatarioVO";
import { FormDestinatariVO } from "@app/shared/vo/gescor/form-destinatariVO";
import { AttoVO } from "@app/shared/vo/attoVO";

@Injectable({
  providedIn: "root",
})
export class MapperCreaPartenza {
  convertUnitaDocumentariaVoToInterface(vo: UnitaDocumentariaVO): FormCreaCorrispondenzaPartenzaVO {

    let i: FormCreaCorrispondenzaPartenzaVO = new FormCreaCorrispondenzaPartenzaVO();
    i.oggetto = vo.oggetto;
    const classifica = new ClassificaVO();
    classifica.nome = vo.classifica.nome;
    classifica.codice = vo.classifica.codice;
    classifica.abilitaInvioComunicazioniDipendenti = vo.classifica.abilitaInvioComunicazioniDipendenti;
    i.classifica.push(classifica);
    i.primario = vo.documentoPrimario;
    i.allegati = vo.allegati;
    i.formDestinatari = new FormDestinatariVO();

    if (vo.tipo === TipoSupportoDocumentoEnum.DIGITALE) {
      i.tipoProtocollo = TipoProtocolloEnum.PARTENZA_DIGITALE;
      i.formDestinatari.tipoPartenzaHidden = TipoSupportoDocumentoEnum.DIGITALE;
    } else {
      i.tipoProtocollo = TipoProtocolloEnum.PARTENZA_CARTACEO;
      i.formDestinatari.tipoPartenzaHidden = TipoSupportoDocumentoEnum.CARTACEO;
    }
    console.log("***** i", JSON.stringify(i));

    return i;

  }


  convertAttoVoToInterface(vo: AttoVO): FormCreaCorrispondenzaPartenzaVO {

    let i: FormCreaCorrispondenzaPartenzaVO = new FormCreaCorrispondenzaPartenzaVO();
    i.oggetto = vo.oggetto;
    const classifica = new ClassificaVO();
    // classifica.nome = vo.classifica.nome;
    // classifica.codice = vo.classifica.codice;
    // classifica.abilitaInvioComunicazioniDipendenti = vo.classifica.abilitaInvioComunicazioniDipendenti;
    // i.classifica.push(classifica);
    // i.primario = vo.primario;
    i.allegati = vo.allegati;
    i.formDestinatari = new FormDestinatariVO();
    i.primario = vo.primario;
    i.tipoProtocollo = TipoProtocolloEnum.PARTENZA_DIGITALE;
    i.formDestinatari.tipoPartenzaHidden = TipoSupportoDocumentoEnum.DIGITALE;

    console.log("***** i", JSON.stringify(i));

    return i;

  }
}
